module.exports = __webpack_public_path__ + "img/jsdt.bc7e184f.png";